import 'rxjs/add/observable/defer';
import 'rxjs/add/observable/empty';
import 'rxjs/add/observable/from';
import 'rxjs/add/observable/interval';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/race';
import 'rxjs/add/observable/throw';
import 'rxjs/add/observable/timer';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/concat';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/delay';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mapTo';
import 'rxjs/add/operator/merge';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/reduce';
import 'rxjs/add/operator/skip';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/take';
import 'rxjs/add/operator/zip';
import { Observable } from 'rxjs/Observable';

import { VersionedData } from '../model';

export { Observable } from 'rxjs/Observable';
export { Observer } from 'rxjs/Observer';
export { Subject } from 'rxjs/Subject';
export { Subscription } from 'rxjs/Subscription';
export { BehaviorSubject } from 'rxjs/BehaviorSubject';
export { ReplaySubject } from 'rxjs/ReplaySubject';

type Stream<T> = Observable<VersionedData<T>>;
type Fetch<T> = () => Stream<T>;
type IncrementalFetch<T> = (version: number) => Stream<T>;

export const pollGeneric = <T>(
  pollingInterval: number,
  manualRefresh: Observable<T>,
  initial: () => Observable<T>,
  followUp: () => Observable<T>
) => {
  const poll = (data: T) =>
    Observable.interval(pollingInterval)
      .switchMap(() => followUp())
      .startWith(data);
  return initial()
    .concat(manualRefresh)
    .switchMap(poll);
};

export const pollVersionedData = <T>(
  pollingInterval: number,
  manualRefresh: Stream<T>,
  initial: Fetch<T>,
  followUp: IncrementalFetch<T>
) => {
  let version: number;
  return pollGeneric(pollingInterval, manualRefresh, initial, () =>
    followUp(version).filter(newData => newData.version > version)
  )
    .do(data => (version = data.version))
    .map(data => data.value);
};
